/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import CustomerSupportNavBar from '../../../../layouts/customer-support/CustomerSupportNavBar';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import CallReportBody from './CallReportBody';

const CustomerSupportCallReport = () => {
  const { profile, user } = useUser();
  const { firstName } = profile;
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <CustomerSupportNavBar currentPage="Call Report" roleID={user.role_id} position={firstName} />
        <div className="mt-5 p-3">
          <CallReportBody />
        </div>
      </main>
    </div>
  );
};

export default CustomerSupportCallReport;
